import { useT } from "@/i18n";
import { useSiteContent, useSiteText } from "@/context/SiteContentContext";
import MicGlitchImage from "@/components/site/MicGlitchImage";
import GlitchText from "@/components/GlitchText";

// Dedicated /lab page — same multimedia experience as the home section but
// full-screen and always accessible. The nav link points here directly so it
// works from any page (no fragile hash-anchor scrolling).
export default function Lab() {
    const { t, lang } = useT();
    const { content: siteContent } = useSiteContent();
    const st = useSiteText(lang, t);

    return (
        <div data-testid="lab-page" className="bg-black text-white min-h-[70vh]">
            <section className="px-4 md:px-8 py-14 md:py-24">
                <div className="grid grid-cols-12 gap-6 md:gap-10 items-center">
                    <div className="col-span-12 md:col-span-5">
                        <div className="font-mono text-xs uppercase tracking-[0.35em] text-[#5D3FD3] mb-4">
                            {st("lab_kicker") || (lang === "es" ? "multimedia" : "multimedia")}
                        </div>
                        <h1 className="font-heading font-black text-5xl sm:text-6xl md:text-7xl uppercase tracking-tighter leading-[0.85] mb-6">
                            <GlitchText>{st("lab_title") || (lang === "es" ? "el lab" : "the lab")}</GlitchText>
                        </h1>
                        <p className="font-body text-base md:text-lg text-white/70 leading-relaxed max-w-md">
                            {st("lab_intro") || (lang === "es"
                                ? "un espacio experimental — arrastrá el mouse sobre la imagen para glitchearla."
                                : "an experimental space — drag your mouse on the image to glitch it.")}
                        </p>
                    </div>
                    <div className="col-span-12 md:col-span-7">
                        {siteContent.lab_glitch_image_url ? (
                            <MicGlitchImage
                                src={siteContent.lab_glitch_image_url}
                                pixelSize={10}
                                aspect={0.75}
                                testid="lab-page-glitch"
                            />
                        ) : (
                            <div className="aspect-[4/3] w-full bg-[#222] flex items-center justify-center px-6" data-testid="lab-page-empty">
                                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 text-center max-w-xs">
                                    {st("lab_default_hint") || "no image configured. set lab_glitch_image_url in admin."}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}
